import React from 'react';
import { motion } from 'framer-motion';
import { ScreenShell, Headline, Subtext } from '../components/ScreenShell';
import { PrimaryButton } from '../components/ui/PrimaryButton';
import { useCopy } from '../contexts/LanguageContext';
interface WelcomeScreenProps {
  parentName: string;
  onStart: () => void;
}
export function WelcomeScreen({
  parentName,
  onStart
}: WelcomeScreenProps) {
  const copy = useCopy();
  const firstName = parentName.trim().split(' ')[0] || copy.welcome.fallbackName;
  return <ScreenShell center data-id="element-196" data-mp="2n0fdbwf7yshf">
      <p className="text-sm font-semibold uppercase tracking-[0.14em] text-violet-500" data-id="element-197" data-mp="2mz4bw398xwth">
        {copy.welcome.greeting(firstName)}
      </p>

      <div className="mt-4" data-id="element-198" data-mp="2w0c7ueoailke">
        <Headline data-id="element-199" data-mp="2w02j0uezekga">{copy.welcome.headline}</Headline>
        <Subtext data-id="element-200" data-mp="2vy9cdf4dc08a">{copy.welcome.subtext}</Subtext>
      </div>

      <ul className="mt-7 space-y-1 rounded-4xl border border-lavender-200 bg-white/90 p-5 shadow-soft" data-id="element-201" data-mp="16m7413jgmfnq">
        {copy.welcome.highlights.map((item, index) => <motion.li key={item.text} initial={{
        opacity: 0,
        x: -10
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.15 + index * 0.1,
        duration: 0.4
      }} className="flex items-center gap-3 py-2.5 text-[15px] text-ink" data-id="element-202" data-mp="1yucqnbtlpdq2" data-mpi={index}>
            <span aria-hidden="true" className="grid h-9 w-9 place-items-center rounded-2xl bg-lavender-100" data-id="element-203" data-mp="2cl94fwivbqd2">
              {item.emoji}
            </span>
            {item.text}
          </motion.li>)}
      </ul>

      <div className="mt-8" data-id="element-204" data-mp="2mhubsoid1dk2">
        <PrimaryButton onClick={onStart} data-id="element-205" data-mp="2ris0ljxvl5uj">{copy.welcome.cta}</PrimaryButton>
      </div>
    </ScreenShell>;
}